import { render, staticRenderFns } from "./CertificateCenters.vue?vue&type=template&id=6a9e8405"
import script from "./CertificateCenters.vue?vue&type=script&lang=js"
export * from "./CertificateCenters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports